<template>
  <div>
    <TopNavbar title="收货地址"></TopNavbar>
    <div class="address">
      <div class="address-edit-box">
        <address-edit
            :area-list="areaList"
            :address-info="defaultAddress"
            @save="onSave"
        ></address-edit>
      </div>
    </div>
  </div>
</template>

<script>
  import areaList from '@/public/area';
  import {AddressEdit, Toast} from "vant"
  import TopNavbar from "../common/TopNavbar";

  export default {
    name: "AddressComponent",
    components: {
      TopNavbar, AddressEdit, Toast
    },
    data() {
      return {
        areaList,
      };
    },
    methods: {
      async onSave(content) {
        // 未登录也调用
        await this.$store.dispatch("UpdateUserAddress", content).then((data) => {
        }, () => {
        })

        Toast('保存成功');
        this.$store.commit("SetAddressList", [content])
        setTimeout(() => {
          this.$router.go(-1);
        }, 500);
      },
      goBack() {
        this.$router.go(-1);
      }
    },
    computed: {
      defaultAddress() {
        let address = this.$store.getters.addressList
        if (address.length > 0) {
          return address[0]
        } else {
          return {}
        }
      },
    }
  };
</script>

<style scoped>
  .address {
    background-color: white;
  }

  .address-edit-box {
    padding-top: 50px;
    position: relative;
  }
</style>
